"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRef = exports.traverse = exports.fromStringPath = exports.toStringPath = exports.pathToStringPath = exports.set3d = exports.get3d = exports.hasByArray = exports.setByString = exports.setByArray = exports.getByString = exports.getByArray = exports.isObjectLike = exports.DEPTH = exports.EMPTY_SCHEMA = exports.EMPTY_ARRAY = exports.SMALL_FACTOR = exports.BIG_FACTOR = void 0;
const PATH_SEPARATOR = '~~';
const Queue_1 = require("./Queue");
exports.BIG_FACTOR = 32;
exports.SMALL_FACTOR = 16;
exports.EMPTY_ARRAY = [];
exports.EMPTY_SCHEMA = Symbol.for('EMPTY_SCHEMA');
exports.DEPTH = 3;
const isObjectLike = (item) => Array.isArray(item) || typeof item === 'object';
exports.isObjectLike = isObjectLike;
const getByArray = (obj, path) => {
    let val = obj;
    for (const pathPart of path) {
        val = val[pathPart];
        if (typeof val === 'undefined') {
            return undefined;
        }
    }
    return val;
};
exports.getByArray = getByArray;
const getByString = (obj, path) => (0, exports.getByArray)(obj, path.split(PATH_SEPARATOR));
exports.getByString = getByString;
const setByArray = (obj, path, value) => {
    let val = obj;
    let i = 0;
    for (; i < path.length - 1; i++) {
        val[path[i]] = val[path[i]] || {};
        val = val[path[i]];
    }
    val[path[i]] = value;
};
exports.setByArray = setByArray;
const setByString = (obj, path, value) => (0, exports.setByArray)(obj, path.split(PATH_SEPARATOR), value);
exports.setByString = setByString;
const hasByArray = (obj, pathArray) => {
    let val = obj;
    for (const pathPart of pathArray) {
        if (val.hasOwnProperty(pathPart)) {
            val = val[pathPart];
        }
        else {
            return false;
        }
    }
    return true;
};
exports.hasByArray = hasByArray;
const get3d = (object, key1, key2, key3) => object[key1]?.[key2]?.[key3];
exports.get3d = get3d;
const set3d = (object, key1, key2, key3, value) => {
    object[key1] = object[key1] || {};
    object[key1][key2] = object[key1][key2] || {};
    object[key1][key2][key3] = value;
};
exports.set3d = set3d;
const pathToStringPath = ([key1, key2, key3]) => (0, exports.toStringPath)(key1, key2, key3);
exports.pathToStringPath = pathToStringPath;
const toStringPath = (key1, key2, key3) => `${key1}${PATH_SEPARATOR}${key2}${PATH_SEPARATOR}${key3}`;
exports.toStringPath = toStringPath;
const fromStringPath = (path) => path.split(PATH_SEPARATOR);
exports.fromStringPath = fromStringPath;
const traverse = (obj, visit, queueFactor) => {
    const queue = new Queue_1.Queue(queueFactor);
    queue.enqueue({ path: [], val: obj });
    while (!queue.isEmpty()) {
        const next = queue.dequeue();
        if (!visit(next.val, next.path)) {
            const type = typeof next.val;
            if (!next.val ||
                type === 'string' ||
                type === 'number' ||
                type === 'boolean' ||
                type === 'symbol' ||
                type === 'function') {
                continue;
            }
            if (Array.isArray(next.val)) {
                for (let i = 0; i < next.val.length; i++) {
                    queue.enqueue({
                        path: [...next.path, i],
                        val: next.val[i],
                    });
                }
            }
            else {
                const keys = Object.keys(next.val);
                for (const key of keys) {
                    queue.enqueue({
                        path: [...next.path, key],
                        val: next.val[key],
                    });
                }
            }
        }
    }
};
exports.traverse = traverse;
const isRef = (x) => typeof x === 'object' && x !== null && x.hasOwnProperty('$type') && x.$type === 'ref';
exports.isRef = isRef;
//# sourceMappingURL=utils.js.map